import React from 'react';
import Modal from '../Modal';
import './Dialog.scss';

const Dialog = ({ children, open, className = null, color = 'red' }) => {
  if (!open) {
    return null;
  }
  return (
    <Modal className={className}>
      <div className="dialog" style={{ '--color': color }}>{children}</div>
    </Modal>
  );
};

export default Dialog;